import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateZone = createAsyncThunk(
  "zones/updateZone",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateZone(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateZoneSLice = createSlice({
  name: "updateZone",
  initialState,
  reducers: {
    clearUpdateZoneResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateZone.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateZone.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateZone.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateZoneList = (state) => state.updateZone.value;
export const updateZoneLoader = (state) => state.updateZone.loading;
export const {clearUpdateZoneResponse} = updateZoneSLice.actions;

export default updateZoneSLice.reducer;
